import { render, staticRenderFns } from "./ProjectShell.vue?vue&type=template&id=5ac29870&"
import script from "./ProjectShell.vue?vue&type=script&lang=js&"
export * from "./ProjectShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports